(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-hound-gallery]').forEach((gallery) => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      gallery.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gallery-target]');
        if (!button) return;
        gallery.querySelectorAll('[data-gallery-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.galleryPanel !== button.dataset.galleryTarget;
        });
        gallery.querySelectorAll('[data-gallery-target]').forEach((thumbnail) => {
          thumbnail.setAttribute('aria-pressed', String(thumbnail === button));
        });
      });
    });
    root.querySelectorAll('[data-hound-product]').forEach((product) => {
      if (product.dataset.initialized) return;
      product.dataset.initialized = 'true';
      product.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-change]');
        if (!button) return;
        const input = product.querySelector('input[name="quantity"]');
        const current = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = Math.max(1, current + Number(button.dataset.quantityChange));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      const variant = product.querySelector('[data-hound-variant]');
      if (variant) variant.addEventListener('change', () => {
        const selected = variant.selectedOptions[0];
        const button = product.querySelector('[data-hound-add]');
        const available = selected.dataset.available === 'true';
        product.querySelector('[data-hound-price]').textContent = selected.dataset.price;
        button.disabled = !available;
        button.innerHTML = available ? 'Add to cart <span aria-hidden="true">↗</span>' : 'Sold out';
      });
    });
    root.querySelectorAll('.hound-mobile-nav nav a').forEach((link) => {
      if (link.dataset.initialized) return;
      link.dataset.initialized = 'true';
      link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
